import React, { useState } from 'react';
import { Button, Checkbox, DatePicker, Form, Input, Progress, Select, Space } from 'antd';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router';
import { EMAIL_REGEX } from '../../helpers';
import { selectMobileDeviceState } from '../../modules/public/globalSettings';
import { checkPasswordStrength, getProgressColor } from '../../helpers/handleEntropyPassword';
export interface SignUpFormProps2 {
    isLoading?: boolean;
    title?: string;
    onSignUp: (values: any) => void;
    onSignIn?: () => void;
    handleSignInGoogle?: (email: string, fullName: string, accessToken: string) => void;
}

const SignUpFormComponent: React.FC<SignUpFormProps2> = ({ isLoading, onSignUp, onSignIn }) => {
    const isMobileDevice = useSelector(selectMobileDeviceState);
    const [passwordStrength, setPasswordStrength] = useState<number>(0);
    const history = useHistory();
    const [form] = Form.useForm();
    const handleFinish = (values: any) => {
        const { terms, confirmPassword, ...filteredValues } = values;
        onSignUp(filteredValues);
    };

    const handleFinishFailed = (errorInfo: any) => {
        console.error('Failed:', errorInfo);
    };

    const handlePasswordStrength = (password: string) => {
        const strength = checkPasswordStrength(password);
        setPasswordStrength(strength);
    };
    return (
        <div className="cr-sign-up-form">
            <div className="cr-sign-up-form__options-group">
                <div className="cr-sign-up-form__option" onClick={onSignIn}>
                    <div className="cr-sign-up-form__option-inner cr-sign-in-form__tab-signin">Sign In</div>
                </div>
                <div className="cr-sign-up-form__option">
                    <div className="cr-sign-up-form__option-inner __selected">Sign Up</div>
                </div>
            </div>
            <Form
                form={form}
                className="cr-sign-up-form__form-content"
                style={isMobileDevice && { padding: '0' }}
                name="signup"
                layout="vertical"
                onFinish={handleFinish}
                onFinishFailed={handleFinishFailed}
                autoComplete="off">
                <Space
                    direction="horizontal"
                    className="cr-sign-up-form__form-content___group"
                    style={{ width: '100%', justifyContent: 'space-between' }}>
                    <Form.Item name="firstName" rules={[{ required: true, message: 'First Name Required' }]}>
                        <Input
                            placeholder="First Name"
                            width={isMobileDevice && '100%'}
                            className="cr-sign-up-form__form-content___input half"
                        />
                    </Form.Item>

                    <Form.Item name="lastName" rules={[{ required: true, message: 'Last Name Required' }]}>
                        <Input
                            placeholder="Last Name"
                            width={isMobileDevice && '100%'}
                            className="cr-sign-up-form__form-content___input half"
                        />
                    </Form.Item>
                </Space>
                <Space
                    direction="horizontal"
                    className="cr-sign-up-form__form-content___group"
                    style={{ width: '100%', justifyContent: 'space-between' }}>
                    <Form.Item name="dob" rules={[{ required: true, message: 'Date Of Birth Required' }]}>
                        <DatePicker
                            placeholder="Date Of Birth"
                            className="cr-sign-up-form__form-content___input half"
                        />
                    </Form.Item>

                    <Form.Item name="campus" rules={[{ required: true, message: 'Campus Required' }]}>
                        <Select
                            placeholder="Campus"
                            options={[
                                { value: 'HoaLac', label: 'FU - Hòa Lạc' },
                                { value: 'HoChiMinh', label: 'FU - Hồ Chí Minh' },
                                { value: 'DaNang', label: 'FU - Đà Nẵng' },
                                { value: 'CanTho', label: 'FU - Cần Thơ' },
                                { value: 'QuyNhon', label: 'FU - Quy Nhơn' },
                            ]}
                            className="cr-sign-up-form__form-content___input half"
                        />
                    </Form.Item>
                </Space>
                <Form.Item
                    style={{ width: '100%' }}
                    name="gender"
                    rules={[{ required: true, message: 'Gender Required' }]}>
                    <Select
                        placeholder="Gender"
                        options={[
                            { value: 'male', label: 'Male' },
                            { value: 'female', label: 'Female' },
                            { value: 'other', label: 'Other' },
                        ]}
                        style={{ width: '100%', height: 45 }}
                        // className="cr-sign-up-form__form-content___input one"
                    />
                </Form.Item>
                <Form.Item
                    name="email"
                    rules={[
                        { required: true, message: 'Email Required' },
                        { pattern: EMAIL_REGEX, message: 'Invalid Email' },
                    ]}>
                    <Input placeholder="Email" className="cr-sign-up-form__form-content___input full" />
                </Form.Item>
                <div className="cr-sign-up-form__form-content____password-wrapper">
                    <Form.Item
                        name="password"
                        rules={[
                            { required: true, message: 'Password must contain at least 8 characters' },
                            // { pattern: PASSWORD_REGEX , message: undefined},
                        ]}>
                        <Input.Password
                            placeholder="Password"
                            onChange={(e) => handlePasswordStrength(e.target.value)}
                            className="cr-sign-up-form__form-content___input full"
                        />
                    </Form.Item>
                    <div className="password-progress">
                        <div>
                            {passwordStrength === 1 && 'Weak'}
                            {passwordStrength === 2 && 'Fair'}
                            {passwordStrength === 3 && 'Good'}
                            {passwordStrength === 4 && 'Strong'}
                        </div>
                        <Progress
                            percent={(passwordStrength / 4) * 100}
                            showInfo={false}
                            strokeColor={getProgressColor(passwordStrength)}
                            trailColor="gray"
                        />
                    </div>
                </div>

                <Form.Item
                    name="confirmPassword"
                    dependencies={['password']}
                    rules={[{ required: true, message: 'Please confirm password!' }]}
                    hasFeedback>
                    <Input.Password
                        placeholder="Confirm Password"
                        className="cr-sign-up-form__form-content___input full"
                    />
                </Form.Item>

                <Form.Item
                    name="terms"
                    valuePropName="checked"
                    rules={[{ required: true, message: 'You must accept the terms and conditions' }]}>
                    <Checkbox>
                        <span className="cr-sign-up-form-checkbox">I agree to the terms and conditions</span>
                    </Checkbox>
                </Form.Item>

                <Form.Item>
                    <Button
                        className="cr-sign-up-form__form-content____btn-submit-sign-up"
                        type="primary"
                        htmlType="submit"
                        block
                        loading={isLoading}>
                        <span className="register-icon"></span>
                        {isLoading ? 'Loading...' : 'Sign Up To Claim 500M Virtual Funds'}
                    </Button>
                </Form.Item>
            </Form>
        </div>
    );
};

export const SignUpForm2 = React.memo(SignUpFormComponent);
